// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { 
  getAuth, 
  signInAnonymously, 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  fetchSignInMethodsForEmail,
  setPersistence,
  browserSessionPersistence,
  sendPasswordResetEmail,
  deleteUser,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
} from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBhlgpa3f_v2MTa0HOkm2h8pk0WiPo9wh0",
  authDomain: "thataihumanizer.firebaseapp.com",
  projectId: "thataihumanizer",
  storageBucket: "thataihumanizer.firebasestorage.app",
  messagingSenderId: "770340088030",
  appId: "1:770340088030:web:7d11a464dd249408b4ba4f",
  measurementId: "G-WB9N0FH0VH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
const auth = getAuth(app);

// Set auth persistence
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window or tab will clear any existing state.
    // ...
    // New sign-in will be persisted with session persistence.
    console.log("Firebase auth persistence set to browserSessionPersistence");
  })
  .catch((error) => {
    // Handle errors here.
    console.error("Error setting Firebase auth persistence:", error);
  });

const googleProvider = new GoogleAuthProvider();

// Helper function to check if an email exists
const checkIfEmailExists = async (email) => {
  try {
    if (!email) return false;
    
    // Alternative approach to check if email exists
    // This uses the fetchSignInMethodsForEmail which is more reliable
    const methods = await fetchSignInMethodsForEmail(auth, email);
    console.log("Firebase sign-in methods for", email, ":", methods);
    
    // If methods array is not empty, the email exists
    return Array.isArray(methods) && methods.length > 0;
  } catch (error) {
    console.error("Firebase email check error:", error);
    
    // Handle different error codes
    if (error.code === 'auth/invalid-email') {
      throw new Error('Invalid email format');
    } else if (error.code === 'auth/user-not-found') {
      // If user not found, email doesn't exist
      return false;
    }
    
    // For any other error, throw it to be handled by the caller
    throw error;
  }
};

// Email verification action code settings
const actionCodeSettings = {
  url: window.location.origin + '/login',
  handleCodeInApp: true
};

export { 
  auth, 
  googleProvider,
  actionCodeSettings,
  signInAnonymously, 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  fetchSignInMethodsForEmail,
  checkIfEmailExists,
  sendPasswordResetEmail,
  deleteUser,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
}; 